import { memo, type RefObject } from 'react';

import { datapointLayout } from './HistogramOverlays.sty.js';
import { Canvas } from '../../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../../core/components/canvas/CanvasContext.js';
import { CanvasShape } from '../../../core/components/canvas/types/canvas-shape.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { OVERLAY_PADDING } from '../../../core/components/data-point/constants.js';
import { DataPointCanvas } from '../../../core/components/data-point/DataPointCanvas.js';
import { DataPoint } from '../../../core/types/data-point.js';

interface HistogramDatapointsCanvasProps {
  /** Datapoints on an X coordinate */
  groupedPoints: DataPoint[][];
  /** Closest point to the mouse position & the x and y position of the tooltip */
  closestPoint?: DataPoint;
}

/**
 * Component for rendering the datapoints on the Y axis based on an X coordinate.
 */
export const HistogramDatapoints = memo(
  (props: HistogramDatapointsCanvasProps) => {
    const { closestPoint, groupedPoints } = props;
    const { width, height } = useGridPlotSize();

    return (
      <div className={datapointLayout}>
        <CanvasContext.Provider
          value={{
            shapeRefs: new Map<string, RefObject<CanvasShape>>(),
          }}
        >
          <Canvas
            width={width + OVERLAY_PADDING * 2}
            height={height + OVERLAY_PADDING * 2}
          >
            {groupedPoints.length > 0 &&
              groupedPoints.map((pointGroup, index) => (
                <DataPointCanvas
                  key={`pointGroup-${index}`}
                  points={pointGroup}
                  closestPoint={closestPoint as DataPoint}
                />
              ))}
          </Canvas>
        </CanvasContext.Provider>
      </div>
    );
  },
);

HistogramDatapoints['displayName'] = 'HistogramDatapoints';
